import { Model } from '@vuex-orm/core'

export default class MZLocationable extends Model {
  static entity = 'mzlocationable'
  static primaryKey = 'id'

  static fields () {
    return {
      location_id: this.string(null),
      locationable_id: this.string(null),
      locationable_type: this.string(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/MZLocationable.js